import { EditButton, Show, SimpleShowLayout, TextField, TopToolbar, useRecordContext } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { FC } from "react";
import { Grid, Typography } from "@mui/material";
import { useSupplierPermissionTranslations } from "@/hooks/translates";

const PermissionShowActions = () => {
  const { hasPermission } = useAdmin();

  return (
    <TopToolbar>
      {hasPermission("supplier-permission.edit") && <EditButton />}
    </TopToolbar>
  );
};

export const SupplierPermissionShow = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("supplier-permission.show")) return null;

  return (
    <Show actions={<PermissionShowActions />}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="key" />
        <SupplierPermissionTranslations />
      </SimpleShowLayout>
    </Show>
  );
};

const SupplierPermissionTranslations: FC = () => {
  const record = useRecordContext<any>();
  const { values } = useSupplierPermissionTranslations(record?.key);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">Translations</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">Name (es)</Typography>
        <Typography variant="body1">{values.nameEs}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">Name (en)</Typography>
        <Typography variant="body1">{values.nameEn}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">Description (es)</Typography>
        <Typography variant="body1">{values.descriptionEs}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2">Description (en)</Typography>
        <Typography variant="body1">{values.descriptionEn}</Typography>
      </Grid>
    </Grid>
  );
};
